'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _findInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/find');
var lodash = require('lodash');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _findInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_findInstanceProperty);

var LoadingJobStyleLogic = /*#__PURE__*/function () {
  function LoadingJobStyleLogic() {
    _classCallCheck__default["default"](this, LoadingJobStyleLogic);
  }
  return _createClass__default["default"](LoadingJobStyleLogic, null, [{
    key: "getUnsavedLoadingJobStyleNames",
    value:
    /**
     * Mark the status on the unsaved loading jobs that have updated styles.
     *
     * @param {DBLoadingJobJson[]} savedDBLoadingJobStyles
     * @param {DBLoadingJobJson[]} inMemoryDBLoadingJobStyles
     * @param {LoadingJobData[]} loadingJobs
     */
    function getUnsavedLoadingJobStyleNames(savedDBLoadingJobStyles, inMemoryDBLoadingJobStyles) {
      var unsavedJobNames = [];
      _forEachInstanceProperty__default["default"](inMemoryDBLoadingJobStyles).call(inMemoryDBLoadingJobStyles, function (inMemoryDBLoadingJobStyle) {
        var oldJobStyle = _findInstanceProperty__default["default"](savedDBLoadingJobStyles).call(savedDBLoadingJobStyles, function (job) {
          return job.loadingJobName === inMemoryDBLoadingJobStyle.loadingJobName;
        });
        if (oldJobStyle !== undefined && !lodash.isEqual(oldJobStyle.loadingStatementsStyle, inMemoryDBLoadingJobStyle.loadingStatementsStyle)) {
          unsavedJobNames.push(inMemoryDBLoadingJobStyle.loadingJobName);
        }
      });
      return unsavedJobNames;
    }
  }]);
}();

exports.LoadingJobStyleLogic = LoadingJobStyleLogic;
